import Component from '../inherited/Component'

export default class AnimationsStickyCta extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._buttonWrapper = this._elem.querySelector('.button-wrapper')
  }

  mount () {
    window.addEventListener('scroll', () => {
      if (this._isElementInViewport()) {
        this._buttonWrapper.classList.add('active')
      } else {
        this._buttonWrapper.classList.remove('active')
      }
    })
  }

  _isElementInViewport () {
    var rect = this._elem.getBoundingClientRect()

    return (
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}